import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { UiCButtonModule } from '@wlp/ui-c-button';

let UiCModalComponent = class UiCModalComponent {
    constructor(modalController) {
        this.modalController = modalController;
        this.doubleButton = false;
        this.clearButton = false;
        this.dismiss = new EventEmitter();
        this.confirm = new EventEmitter();
    }
    dismissMethod() {
        this.dismiss.emit();
    }
    continueMethod() {
        this.confirm.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCModalComponent.prototype, "disabledConfirm", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCModalComponent.prototype, "disabledDismiss", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCModalComponent.prototype, "modalImage", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCModalComponent.prototype, "modalTitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCModalComponent.prototype, "dismissText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCModalComponent.prototype, "confirmText", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCModalComponent.prototype, "doubleButton", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCModalComponent.prototype, "clearButton", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCModalComponent.prototype, "dismiss", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCModalComponent.prototype, "confirm", void 0);
UiCModalComponent = __decorate([
    Component({
        selector: 'ui-c-modal',
        template: "<div class=\"modal-component p-0\">\n  <ion-grid class=\"ion-grid\">\n    <ng-container *ngIf=\"!!modalImage\">\n      <ion-row class=\"ion-justify-content-center ion-text-center\">\n        <ion-col size=\"10\" id=\"col-modal-image\" class=\"ion-padding\">\n          <svg-icon [stretch]=\"false\" class=\"ion-img\" [src]=\"modalImage\"> </svg-icon>\n        </ion-col>\n      </ion-row>\n    </ng-container>\n\n    <ion-row>\n      <ion-col class=\"ion-padding-horizontal\">\n        <ion-title *ngIf=\"modalTitle\" class=\"ion-title ion-no-padding ion-margin-vertical\">\n          <ion-text class=\"modal-title\">\n            {{ modalTitle }}\n          </ion-text>\n        </ion-title>\n        <ion-text class=\"ion-text ion-margin-vertical\">\n          <ng-content></ng-content>\n        </ion-text>\n      </ion-col>\n    </ion-row>\n\n    <div\n      class=\"group-buttons no-double-button\"\n      *ngIf=\"!doubleButton && !clearButton && ((dismiss && dismissText) || (confirm && confirmText))\"\n    >\n      <div class=\"container\">\n        <ion-row class=\"ion-justify-content-end alignment\">\n          <ion-col size=\"12\" *ngIf=\"dismiss && dismissText\" class=\"ion-col ion-padding-vertical\">\n            <ui-c-button data-cy=\"log-continue-btn\" [disabled]=\"disabledDismiss\" expand=\"block\" (continue)=\"dismissMethod()\"\n              >{{ dismissText }}\n            </ui-c-button>\n          </ion-col>\n          <ion-col size=\"12\" *ngIf=\"confirm && confirmText\" class=\"ion-col ion-padding-vertical\">\n            <ui-c-button data-cy=\"log-cancel-btn\" [disabled]=\"disabledConfirm\" expand=\"block\" (continue)=\"continueMethod()\"\n              >{{ confirmText }}\n            </ui-c-button>\n          </ion-col>\n        </ion-row>\n      </div>\n    </div>\n\n    <div class=\"group-buttons double-button\" *ngIf=\"doubleButton\">\n      <div class=\"container\">\n        <ion-row class=\"d-flex ion-justify-content-around alignment\">\n          <ion-col class=\"ion-col ion-padding-vertical\">\n            <ui-c-button data-cy=\"log-continue-btn\" expand=\"block\" (continue)=\"continueMethod()\">{{ confirmText }}</ui-c-button>\n          </ion-col>\n          <ion-col class=\"ion-col ion-padding-vertical\">\n            <ui-c-button data-cy=\"log-cancel-btn\" expand=\"block\" (continue)=\"dismissMethod()\">{{ dismissText }}</ui-c-button>\n          </ion-col>\n        </ion-row>\n      </div>\n    </div>\n\n    <div\n      class=\"group-buttons clear-button\"\n      *ngIf=\"clearButton && ((dismiss && dismissText) || (confirm && confirmText))\"\n    >\n      <div class=\"container\">\n        <ion-row class=\"ion-justify-content-end\">\n          <ion-col *ngIf=\"confirm && confirmText\" size=\"12\" class=\"ion-col ion-padding-vertical btn-continue\">\n            <ui-c-button data-cy=\"log-continue-btn\" expand=\"block\" (continue)=\"continueMethod()\">{{ confirmText }}</ui-c-button>\n          </ion-col>\n          <ion-col *ngIf=\"dismiss && dismissText\" size=\"12\" class=\"ion-col ion-padding-vertical btn-return\">\n            <ui-c-button data-cy=\"log-cancel-btn\" expand=\"block\" fill=\"clear\" (continue)=\"dismissMethod()\">{{ dismissText }}</ui-c-button>\n          </ion-col>\n        </ion-row>\n      </div>\n    </div>\n  </ion-grid>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [ModalController])
], UiCModalComponent);

let UiCModalModule = class UiCModalModule {
};
UiCModalModule = __decorate([
    NgModule({
        declarations: [UiCModalComponent],
        imports: [IonicModule, CommonModule, UiCButtonModule, AngularSvgIconModule.forRoot()],
        exports: [UiCModalComponent],
    })
], UiCModalModule);

export { UiCModalComponent, UiCModalModule };
//# sourceMappingURL=wlp-ui-c-modal.js.map
